(() => {
  let e = (e = 30) => [
      "elInY+elHeight",
      `elCenterY-${e}`,
      "elCenterY",
      `elCenterY+${e}`,
      "elOutY-elHeight",
    ],
    t = {
      fadeInOut: (t = 30, s = 0) => ({ opacity: [e(t), [s, 1, 1, 1, s]] }),
      fadeIn: (e = "elCenterY", t = 0) => ({
        opacity: [
          ["elInY+elHeight", e],
          [t, 1],
        ],
      }),
      fadeOut: (e = "elCenterY", t = 0) => ({
        opacity: [
          [e, "elOutY-elHeight"],
          [1, t],
        ],
      }),
      blurInOut: (t = 100, s = 20) => ({ blur: [e(t), [s, 0, 0, 0, s]] }),
      blurIn: (e = "elCenterY", t = 20) => ({
        blur: [
          ["elInY+elHeight", e],
          [t, 0],
        ],
      }),
      blurOut: (e = "elCenterY", t = 20) => ({
        opacity: [
          [e, "elOutY-elHeight"],
          [0, t],
        ],
      }),
      scaleInOut: (t = 100, s = 0.6) => ({ scale: [e(t), [s, 1, 1, 1, s]] }),
      scaleIn: (e = "elCenterY", t = 0.6) => ({
        scale: [
          ["elInY+elHeight", e],
          [t, 1],
        ],
      }),
      scaleOut: (e = "elCenterY", t = 0.6) => ({
        scale: [
          [e, "elOutY-elHeight"],
          [1, t],
        ],
      }),
      slideX: (e = 0, t = 500) => ({
        translateX: [
          ["elInY", e],
          [0, t],
        ],
      }),
      slideY: (e = 0, t = 500) => ({
        translateY: [
          ["elInY", e],
          [0, t],
        ],
      }),
      spin: (e = 1e3, t = 360) => ({
        rotate: [[0, e], [0, t], { modValue: e }],
      }),
      flipX: (e = 1e3, t = 360) => ({
        rotateX: [[0, e], [0, t], { modValue: e }],
      }),
      flipY: (e = 1e3, t = 360) => ({
        rotateY: [[0, e], [0, t], { modValue: e }],
      }),
      jiggle: (e = 50, t = 40) => ({
        skewX: [
          [0, 1 * e, 2 * e, 3 * e, 4 * e],
          [0, t, 0, -t, 0],
          { modValue: 4 * e },
        ],
      }),
      seesaw: (e = 50, t = 40) => ({
        skewY: [
          [0, 1 * e, 2 * e, 3 * e, 4 * e],
          [0, t, 0, -t, 0],
          { modValue: 4 * e },
        ],
      }),
      zigzag: (e = 100, t = 100) => ({
        translateX: [
          [0, 1 * e, 2 * e, 3 * e, 4 * e],
          [0, t, 0, -t, 0],
          { modValue: 4 * e },
        ],
      }),
      hueRotate: (e = 600, t = 360) => ({
        "hue-rotate": [[0, e], [0, t], { modValue: e }],
      }),
    },
    s = (() => {
      let e = [
          "perspective",
          "scaleX",
          "scaleY",
          "scale",
          "skewX",
          "skewY",
          "skew",
          "rotateX",
          "rotateY",
          "rotate",
        ],
        s = ["blur", "hue-rotate", "brightness"],
        l = ["translateX", "translateY", "translateZ"],
        a = [
          "perspective",
          "border-radius",
          "blur",
          "translateX",
          "translateY",
          "translateZ",
        ],
        r = [
          "hue-rotate",
          "rotate",
          "rotateX",
          "rotateY",
          "skew",
          "skewX",
          "skewY",
        ];
      function n(e, t) {
        if (Array.isArray(e)) return e;
        let s = Object.keys(e)
            .map((e) => parseInt(e))
            .sort((e, t) => (e > t ? 1 : -1)),
          l = s[s.length - 1];
        for (let a = 0; a < s.length; a++) {
          let r = s[a];
          if (t < r) {
            l = r;
            break;
          }
        }
        return e[l];
      }
      function i(e, t, s) {
        return e * (1 - s) + t * s;
      }
      function o(e, t, s) {
        return (s - e) / (t - e);
      }
      function $(e, t, s, l) {
        let a = 0;
        if (
          (e.forEach((e) => {
            e < s && a++;
          }),
          a <= 0)
        )
          return t[0];
        if (a >= e.length) return t[e.length - 1];
        let r = a - 1,
          n = o(e[r], e[a], s);
        l && (n = l(n));
        let $ = i(t[r], t[a], n);
        return $;
      }
      let h = {
        easeInQuad: (e) => e * e,
        easeOutQuad: (e) => e * (2 - e),
        easeInOutQuad: (e) => (e < 0.5 ? 2 * e * e : -1 + (4 - 2 * e) * e),
        easeInCubic: (e) => e * e * e,
        easeOutCubic: (e) => --e * e * e + 1,
        easeInOutCubic: (e) =>
          e < 0.5 ? 4 * e * e * e : (e - 1) * (2 * e - 2) * (2 * e - 2) + 1,
        easeInQuart: (e) => e * e * e * e,
        easeOutQuart: (e) => 1 - --e * e * e * e,
        easeInOutQuart: (e) =>
          e < 0.5 ? 8 * e * e * e * e : 1 - 8 * --e * e * e * e,
        easeInQuint: (e) => e * e * e * e * e,
        easeOutQuint: (e) => 1 + --e * e * e * e * e,
        easeInOutQuint: (e) =>
          e < 0.5 ? 16 * e * e * e * e * e : 1 + 16 * --e * e * e * e * e,
        easeOutBounce: (e) =>
          e < 0.36363636363636365
            ? 7.5625 * e * e
            : e < 0.7272727272727273
            ? 7.5625 * (e -= 0.5454545454545454) * e + 0.75
            : e < 0.9090909090909091
            ? 7.5625 * (e -= 0.8181818181818182) * e + 0.9375
            : 7.5625 * (e -= 0.9545454545454546) * e + 0.984375,
        easeInBounce: (e) => 1 - h.easeOutBounce(1 - e),
        easeOutBack: (e) =>
          1 + 2.70158 * Math.pow(e - 1, 3) + 1.70158 * Math.pow(e - 1, 2),
        easeInBack: (e) => 2.70158 * e * e * e - 1.70158 * e * e,
      };
      function u(t) {
        let n = { transform: "", filter: "" },
          i = { translateX: 1e-5, translateY: 1e-5, translateZ: 1e-5 };
        return (
          Object.keys(t).forEach((o) => {
            let $ = t[o],
              h = a.includes(o) ? "px" : r.includes(o) ? "deg" : "";
            l.includes(o)
              ? (i[o] = $)
              : e.includes(o)
              ? (n.transform += `${o}(${$}${h}) `)
              : s.includes(o)
              ? (n.filter += `${o}(${$}${h}) `)
              : (n[o] = `${$}${h} `);
          }),
          (n.transform = `translate3d(${i.translateX}px, ${i.translateY}px, ${i.translateZ}px) ${n.transform}`),
          n
        );
      }
      function d() {
        let e = void 0 !== window.pageXOffset,
          t = "CSS1Compat" === (document.compatMode || ""),
          s = e
            ? window.pageXOffset
            : t
            ? document.documentElement.scrollLeft
            : document.body.scrollLeft,
          l = e
            ? window.pageYOffset
            : t
            ? document.documentElement.scrollTop
            : document.body.scrollTop;
        return [l, s];
      }
      function m(e, { width: t, height: s, x: l, y: a }, r) {
        if ("number" == typeof e) return e;
        let n = document.body.scrollHeight,
          i = document.body.scrollWidth,
          o = window.innerWidth,
          $ = window.innerHeight,
          [h, u] = d(),
          m = l + u,
          c = a + h;
        return Function(
          `return ${e
            .replace(/screenWidth/g, o)
            .replace(/screenHeight/g, $)
            .replace(/pageHeight/g, n)
            .replace(/pageWidth/g, i)
            .replace(/elWidth/g, t)
            .replace(/elHeight/g, s)
            .replace(/elInY/g, c - $)
            .replace(/elOutY/g, c + s)
            .replace(/elCenterY/g, c + s / 2 - $ / 2)
            .replace(/elInX/g, m - o)
            .replace(/elOutX/g, m + t)
            .replace(/elCenterX/g, m + t / 2 - o / 2)
            .replace(/index/g, r)}`
        )();
      }
      class c {
        getValueFn;
        name = "";
        lastValue = 0;
        frameStep = 1;
        m1 = 0;
        m2 = 0;
        inertia = 0;
        inertiaEnabled = !1;
        constructor(e, t, s = {}) {
          (this.name = e),
            (this.getValueFn = t),
            Object.keys(s).forEach((e) => {
              this[e] = s[e];
            }),
            (this.lastValue = this.getValueFn(0));
        }
        getValue = (e) => {
          let t = this.lastValue;
          if (
            (e % this.frameStep == 0 && (t = this.getValueFn(e)),
            this.inertiaEnabled)
          ) {
            let s = t - this.lastValue;
            (this.m1 = 0.8 * this.m1 + 0.19999999999999996 * s),
              (this.m2 = 0.8 * this.m2 + 0.19999999999999996 * this.m1),
              (this.inertia = Math.round(5e3 * this.m2) / 15e3);
          }
          return (this.lastValue = t), [this.lastValue, this.inertia];
        };
      }
      class f {
        domElement;
        transformsData;
        styles = {};
        selector = "";
        groupIndex = 0;
        laxInstance;
        onUpdate;
        constructor(e, t, s, l, a = 0, r = {}) {
          (this.selector = e),
            (this.laxInstance = t),
            (this.domElement = s),
            (this.transformsData = l),
            (this.groupIndex = a);
          let { style: n = {}, onUpdate: i } = r;
          Object.keys(n).forEach((e) => {
            s.style.setProperty(e, n[e]);
          }),
            i && (this.onUpdate = i),
            this.calculateTransforms();
        }
        update = (e, t) => {
          let { transforms: s } = this,
            l = {};
          for (let n in s) {
            let i = s[n];
            e[n] || console.error("No lax driver with name: ", n);
            let [o, u] = e[n];
            for (let d in i) {
              let [m, c, f = {}] = i[d],
                {
                  modValue: p,
                  frameStep: g = 1,
                  easing: _,
                  inertia: w,
                  inertiaMode: b,
                  cssFn: y,
                  cssUnit: Y = "",
                } = f,
                E = h[_];
              if (t % g == 0) {
                let I = p ? o % p : o,
                  O = $(m, c, I, E);
                if (w) {
                  let x = u * w;
                  "absolute" === b && (x = Math.abs(x)), (O += x);
                }
                Y || a.includes(d) || r.includes(d);
                let H = O;
                l[d] = y ? y(H, this.domElement) : H + Y;
              }
            }
          }
          this.applyStyles(l),
            this.onUpdate && this.onUpdate(e, this.domElement);
        };
        calculateTransforms = () => {
          this.transforms = {};
          let e = this.laxInstance.windowWidth;
          for (let t in this.transformsData) {
            let s = this.transformsData[t],
              l = {},
              { presets: a = [] } = s;
            for (let r in (a.forEach((e) => {
              let [t, l, a] = e.split(":"),
                r = window.lax.presets[t];
              if (r) {
                let n = r(l, a);
                Object.keys(n).forEach((e) => {
                  s[e] = n[e];
                });
              } else console.error("Lax preset cannot be found with name: ", t);
            }),
            delete s.presets,
            s)) {
              let [i = [-1e9, 1e9], o = [-1e9, 1e9], $ = {}] = s[r],
                h = this.domElement.style.transform;
              this.domElement.style.removeProperty("transform");
              let u = this.domElement.getBoundingClientRect();
              this.domElement.style.transform = h;
              let d = n(i, e).map((e) => m(e, u, this.groupIndex)),
                c = n(o, e).map((e) => m(e, u, this.groupIndex));
              l[r] = [d, c, $];
            }
            this.transforms[t] = l;
          }
        };
        applyStyles = (e) => {
          let t = u(e);
          Object.keys(t).forEach((e) => {
            this.domElement.style.setProperty(e, t[e]);
          });
        };
      }
      class p {
        drivers = [];
        elements = [];
        frame = 0;
        debug = !1;
        windowWidth = 0;
        windowHeight = 0;
        presets = t;
        debugData = { frameLengths: [] };
        init = () => {
          this.findAndAddElements(),
            window.requestAnimationFrame(this.onAnimationFrame),
            (this.windowWidth = document.body.clientWidth),
            (this.windowHeight = document.body.clientHeight),
            (window.onresize = this.onWindowResize);
        };
        onWindowResize = () => {
          let e =
            document.body.clientWidth !== this.windowWidth ||
            document.body.clientHeight !== this.windowHeight;
          e &&
            ((this.windowWidth = document.body.clientWidth),
            (this.windowHeight = document.body.clientHeight),
            this.elements.forEach((e) => e.calculateTransforms()));
        };
        onAnimationFrame = (e) => {
          this.debug && (this.debugData.frameStart = Date.now());
          let t = {};
          if (
            (this.drivers.forEach((e) => {
              t[e.name] = e.getValue(this.frame);
            }),
            this.elements.forEach((e) => {
              e.update(t, this.frame);
            }),
            this.debug &&
              this.debugData.frameLengths.push(
                Date.now() - this.debugData.frameStart
              ),
            this.frame % 60 == 0 && this.debug)
          ) {
            let s = Math.ceil(
              this.debugData.frameLengths.reduce((e, t) => e + t, 0) / 60
            );
            console.log(`Average frame calculation time: ${s}ms`),
              (this.debugData.frameLengths = []);
          }
          this.frame++, window.requestAnimationFrame(this.onAnimationFrame);
        };
        addDriver = (e, t, s = {}) => {
          this.drivers.push(new c(e, t, s));
        };
        removeDriver = (e) => {
          this.drivers = this.drivers.filter((t) => t.name !== e);
        };
        findAndAddElements = () => {
          this.elements = [];
          let e = document.querySelectorAll(".lax");
          e.forEach((e) => {
            let t = [];
            e.classList.forEach((e) => {
              if (e.includes("lax_preset")) {
                let s = e.replace("lax_preset_", "");
                t.push(s);
              }
            });
            let s = { scrollY: { presets: t } };
            this.elements.push(new f(".lax", this, e, s, 0, {}));
          });
        };
        addElements = (e, t, s = {}) => {
          let l = s.domElements || document.querySelectorAll(e);
          l.forEach((l, a) => {
            this.elements.push(new f(e, this, l, t, a, s));
          });
        };
        removeElements = (e) => {
          this.elements = this.elements.filter((t) => t.selector !== e);
        };
        addElement = (e, t, s) => {
          this.elements.push(new f("", this, e, t, 0, s));
        };
        removeElement = (e) => {
          this.elements = this.elements.filter((t) => t.domElement !== e);
        };
      }
      return new p();
    })();
  "undefined" != typeof module && void 0 !== module.exports
    ? (module.exports = s)
    : (window.lax = s);
})();
